export default "__VITE_ASSET__7KZF9LYF__"